export default "__VITE_ASSET__DSDwIXXZ__"